module.exports = __webpack_public_path__ + "img/logo.5dbe9f79.png";